var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 10.0001C18.3332 8.35191 17.8444 6.74074 16.9288 5.37033C16.0131 3.99992 14.7116 2.93182 13.1889 2.30109C11.6662 1.67036 9.9906 1.50533 8.37409 1.82687C6.75758 2.14842 5.27272 2.94209 4.10728 4.10753C2.94185 5.27297 2.14817 6.75782 1.82663 8.37433C1.50509 9.99084 1.67011 11.6664 2.30084 13.1891C2.93158 14.7118 3.99968 16.0133 5.37009 16.929C6.7405 17.8447 8.35166 18.3334 9.99984 18.3334C12.2092 18.3308 14.3273 17.452 15.8895 15.8898C17.4518 14.3275 18.3306 12.2094 18.3332 10.0001ZM17.2916 10.0001C17.2916 11.4423 16.864 12.8521 16.0627 14.0512C15.2615 15.2503 14.1227 16.1849 12.7903 16.7368C11.4579 17.2887 9.99173 17.4331 8.57727 17.1518C7.1628 16.8704 5.86353 16.1759 4.84375 15.1561C3.82398 14.1364 3.12951 12.8371 2.84815 11.4226C2.5668 10.0082 2.7112 8.54202 3.2631 7.20962C3.815 5.87722 4.74961 4.7384 5.94874 3.93717C7.14787 3.13594 8.55766 2.70829 9.99984 2.70829C11.9331 2.7105 13.7865 3.47945 15.1535 4.84645C16.5205 6.21345 17.2894 8.06686 17.2916 10.0001H17.2916ZM10.7637 6.90612H9.2128V5.3552H10.7637V6.90612ZM9.22053 8.4414H10.7869V14.645H9.22053V8.4414Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.22ea1de369e2ebe17d982536efdaf02f.svg";
export { ForwardRef as ReactComponent };